(function () {
  'use strict';

  var PRODUCT_HANDLE = 'dd-shipping-protection';
  var PRODUCT_ID = 10266015924541;
  var CACHE_KEY = 'dd_prot_v1';
  var WIDGET_SEL = '[data-dd-protection]';
  var TOGGLE_SEL = '[data-dd-protection-toggle]';
  var PRICE_SEL = '[data-dd-protection-price]';
  var _isProcessing = false;
  var _visualToggleState = null;
  var _isCartPage = /\/cart\b/.test(window.location.pathname);

  /* ── Shipping protection rate (parity with live / bugfix3) ─────────
     $1 per $100 of merchandise subtotal (before discount), rounded up
     to the next $100 increment. Max coverage basis capped at $5,000. */
  function calcFeeDollars(subtotalCents) {
    var cappedCents = Math.min(Math.max(subtotalCents, 0), 500000);
    if (cappedCents === 0) return 0;
    var increments = Math.ceil(cappedCents / 10000);
    return increments;
  }

  /**
   * Catalog fee in cents for the variant that matches subtotal (authoritative
   * price may differ from calcFeeDollars*100 when only certain $ variants exist).
   */
  function effectiveFeeCents(subtotalCents) {
    if (!_variantMap) return calcFeeDollars(subtotalCents) * 100;
    var vid = selectVariantId(subtotalCents);
    if (!vid) return calcFeeDollars(subtotalCents) * 100;
    var keys = Object.keys(_variantMap);
    for (var i = 0; i < keys.length; i++) {
      if (_variantMap[keys[i]] === vid) return parseInt(keys[i], 10) * 100;
    }
    return calcFeeDollars(subtotalCents) * 100;
  }

  /* ── Money formatting ──────────────────────────── */

  function formatMoney(cents) {
    var fmt = (window.shopMoneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var amount = (cents / 100).toFixed(2);
    var amountWithCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = fmt
      .replace(/\{\{\s*amount\s*\}\}/, amountWithCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toString());
    // Match Liquid's `money_without_trailing_zeros` for UI consistency.
    return out.replace(/([.,])00(?!\d)/, '');
  }

  /* ── Item identification ───────────────────────── */

  function hasProtectionMarker(item) {
    var props = item && item.properties && typeof item.properties === 'object' ? item.properties : null;
    if (!props) return false;
    return !!(props._dd_shipping_protection || props.dd_shipping_protection);
  }

  function isOurItem(item) {
    if (!item) return false;
    if (hasProtectionMarker(item)) return true;
    if (item.product_id === PRODUCT_ID) return true;
    return (item.handle || '').toLowerCase() === PRODUCT_HANDLE;
  }

  function isAnyProtectionItem(item) {
    if (!item) return false;
    if (hasProtectionMarker(item)) return true;
    if (isOurItem(item)) return true;
    var v = (item.vendor || '').toLowerCase();
    var t = (item.title || '').toLowerCase();
    return v.indexOf('insureshield') !== -1
      || v.indexOf('insure shield') !== -1
      || t.indexOf('shipping protection') !== -1
      || t.indexOf('shipping insurance') !== -1;
  }

  function findOurItem(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (isOurItem(items[i])) return items[i];
    }
    return null;
  }

  function findAllProtectionItems(cart) {
    var items = cart.items || [];
    var found = [];
    for (var i = 0; i < items.length; i++) {
      if (isAnyProtectionItem(items[i])) found.push(items[i]);
    }
    return found;
  }

  function merchandiseSubtotal(cart) {
    /* Protection fee is based on merchandise BEFORE cart discounts (live theme). */
    var subtotal = 0;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (isAnyProtectionItem(item)) continue;
      subtotal += item.original_line_price || 0;
    }
    return Math.max(0, subtotal);
  }

  function hasMerchandiseItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!isAnyProtectionItem(item) && (item.quantity || 0) > 0) return true;
    }
    return false;
  }

  function findAnyProtectionItem(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (isAnyProtectionItem(items[i])) return items[i];
    }
    return null;
  }

  function calcDiscountedFee(cart, feeCents) {
    /* Intentionally no discount scaling (live theme): fee follows pre-discount subtotal. */
    return feeCents;
  }

  function discountedPreviewFeeCents(cart) {
    var subtotal = merchandiseSubtotal(cart);
    var baseFee = effectiveFeeCents(subtotal);
    return calcDiscountedFee(cart, baseFee);
  }

  /* ── Variant map: { feeDollars -> variantId } ──── */

  var _variantMap = null;

  function getCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function setCache(map) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(map));
    } catch (e) { /* silent */ }
  }

  function discoverVariants() {
    if (_variantMap) return Promise.resolve(_variantMap);

    var cached = getCache();
    if (cached && typeof cached === 'object' && Object.keys(cached).length > 1) {
      _variantMap = cached;
      return Promise.resolve(_variantMap);
    }

    if (window.ddCartHelpers && typeof window.ddCartHelpers.recordRequest === 'function') {
      window.ddCartHelpers.recordRequest('/products/' + PRODUCT_HANDLE + '.js', 'protection-variants', 'shipping-protection');
    }
    return fetch('/products/' + PRODUCT_HANDLE + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Product not found');
        return r.json();
      })
      .then(function (data) {
        var map = {};
        if (data && data.variants) {
          for (var i = 0; i < data.variants.length; i++) {
            var v = data.variants[i];
            var priceDollars = Math.round(v.price / 100);
            map[priceDollars] = String(v.id);
          }
        }
        _variantMap = map;
        setCache(map);
        return map;
      })
      .catch(function (err) {
        console.warn('[ShippingProtection] Could not load variants:', err.message);
        return null;
      });
  }

  function selectVariantId(subtotalCents) {
    if (!_variantMap) return null;
    var fee = calcFeeDollars(subtotalCents);
    if (_variantMap[fee]) return _variantMap[fee];
    var keys = Object.keys(_variantMap).map(Number).sort(function (a, b) { return a - b; });
    for (var i = 0; i < keys.length; i++) {
      if (keys[i] >= fee) return _variantMap[keys[i]];
    }
    return _variantMap[String(keys[keys.length - 1])] || null;
  }

  /* ── Dawn section rendering helpers ────────────── */

  function getRequestSections() {
    if (_isCartPage) {
      var secs = ['cart-icon-bubble'];
      var el1 = document.getElementById('main-cart-items');
      var el2 = document.getElementById('main-cart-footer');
      if (el1 && el1.dataset.id) secs.push(el1.dataset.id);
      if (el2 && el2.dataset.id) secs.push(el2.dataset.id);
      return secs;
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function hasFullCartShape(cart) {
    return !!(cart && Array.isArray(cart.items) && typeof cart.total_price === 'number');
  }

  function getCachedOrFetchCart() {
    if (window.ddCartHelpers && typeof window.ddCartHelpers.ensureFreshCart === 'function') {
      return window.ddCartHelpers.ensureFreshCart();
    }
    var cached = window.ddCartHelpers && window.ddCartHelpers.getLatestCart
      ? window.ddCartHelpers.getLatestCart()
      : null;
    if (hasFullCartShape(cached)) return Promise.resolve(cached);
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Cart fetch failed (' + r.status + ')');
      return r.json();
    });
  }

  function fetchFreshCart() {
    if (window.ddCartHelpers && typeof window.ddCartHelpers.ensureFreshCart === 'function') {
      return window.ddCartHelpers.ensureFreshCart({ forceNetwork: true });
    }
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('Fresh cart fetch failed (' + r.status + ')');
      return r.json();
    });
  }

  function mutateCart(endpoint, body, actionName) {
    if (window.ddCartHelpers && typeof window.ddCartHelpers.cartMutate === 'function') {
      return window.ddCartHelpers.cartMutate(endpoint, body, {
        sections: getRequestSections(),
        action: actionName || 'protection-mutate'
      });
    }
    var payload = Object.assign({}, body, { sections: getRequestSections() });
    if (window.ddCartHelpers && typeof window.ddCartHelpers.recordRequest === 'function') {
      window.ddCartHelpers.recordRequest(endpoint, actionName || 'protection-mutate', 'shipping-protection-fallback');
    }
    return fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart mutate failed (' + r.status + ')');
      return r.json();
    });
  }

  function getMiniCartSubtotalHost() {
    return document.querySelector('#CartDrawer [data-dd-subtotal]');
  }

  function setMiniCartSubtotalShimmer(active) {
    var host = getMiniCartSubtotalHost();
    if (!host) return;
    if (active) host.classList.add('dd-mutate-shimmer');
    else host.classList.remove('dd-mutate-shimmer');
  }

  /* ── Widget sync (after DOM replacement) ────────── */

  function syncWidgets(cart) {
    var widgets = document.querySelectorAll(WIDGET_SEL);
    if (!widgets.length) return;

    var ours = findOurItem(cart);
    var anyProt = findAnyProtectionItem(cart);
    var displayCents = discountedPreviewFeeCents(cart);

    widgets.forEach(function (ui) {
      var priceEl = ui.querySelector(PRICE_SEL);
      var toggleEl = ui.querySelector(TOGGLE_SEL);
      if (!toggleEl) return;
      if (priceEl) priceEl.textContent = formatMoney(displayCents);

      if (ours) {
        toggleEl.dataset.variantId = String(ours.variant_id);
        if (ours.key) toggleEl.dataset.lineKey = String(ours.key);
        else delete toggleEl.dataset.lineKey;
      } else {
        delete toggleEl.dataset.variantId;
        delete toggleEl.dataset.lineKey;
      }

      if (_visualToggleState === null) {
        _visualToggleState = !!toggleEl.checked;
      }

      /* Visual persistence contract:
         keep the toggle in its last user-chosen state across cart mutations.
         We still update price/variant metadata from cart truth. */
      var nextVisual = _visualToggleState;
      toggleEl.checked = nextVisual;
      ui.classList.toggle('is--active', nextVisual);

      /* Safety: if widget says ON but protection truly absent after a completed
         operation, normalize visual state to OFF. */
      if (!_isProcessing && !anyProt && _visualToggleState === true) {
        _visualToggleState = false;
        toggleEl.checked = false;
        ui.classList.remove('is--active');
      }
    });
  }

  function forceRemoveAllProtection(initialCart, maxAttempts) {
    var attemptsLeft = typeof maxAttempts === 'number' ? maxAttempts : 2;

    function step(cart) {
      var allProt = findAllProtectionItems(cart);
      if (!allProt.length) return Promise.resolve(cart);
      if (attemptsLeft <= 0) throw new Error('Protection line still present after enforced removal');

      attemptsLeft -= 1;
      var updates = {};
      allProt.forEach(function (item) { updates[item.key] = 0; });

      return mutateCart('/cart/update.js', { updates: updates }, 'protection-remove-enforce')
        .then(function (nextCart) {
          if (hasFullCartShape(nextCart)) return step(nextCart);
          return fetchFreshCart().then(step);
        });
    }

    return step(initialCart);
  }

  /* ── Init ───────────────────────────────────────── */

  var _isReconciling = false;

  function reconcileFromCart(cart) {
    if (!hasFullCartShape(cart)) return Promise.resolve();

    /* Immediate UI sync from authoritative payload. */
    syncWidgets(cart);

    /* Reconciliation can decide to mutate cart (cleanup or tier swap). */
    if (_isProcessing || _isReconciling) return Promise.resolve();
    _isReconciling = true;

    return discoverVariants()
      .then(function () {
        var anyProt = findAnyProtectionItem(cart);
        var hasMerch = hasMerchandiseItems(cart);

        if (anyProt && !hasMerch) {
          var updates = {};
          findAllProtectionItems(cart).forEach(function (item) {
            updates[item.key] = 0;
          });
          _isProcessing = true;
          return mutateCart('/cart/update.js', { updates: updates }, 'protection-cleanup')
            .then(function (nextCart) {
              if (hasFullCartShape(nextCart)) {
                if (!findAnyProtectionItem(nextCart)) _visualToggleState = false;
                syncWidgets(nextCart);
              }
            })
            .finally(function () {
              _isProcessing = false;
            });
        }

        var ours = findOurItem(cart);
        if (!ours) return;

        var subtotal = merchandiseSubtotal(cart);
        var feeCents = effectiveFeeCents(subtotal);
        if (ours.price !== feeCents) {
          var newVid = selectVariantId(subtotal);
          if (newVid && String(ours.variant_id) !== newVid) {
            return swapVariant(ours.key, newVid);
          }
        }
      })
      .catch(function (err) {
        console.error('[ShippingProtection] reconcile error', err);
      })
      .finally(function () {
        _isReconciling = false;
      });
  }

  function bootstrapFromCart() {
    var widgets = document.querySelectorAll(WIDGET_SEL);
    if (!widgets.length) return;
    Promise.all([getCachedOrFetchCart(), discoverVariants()])
      .then(function (results) {
        return reconcileFromCart(results[0]);
      })
      .catch(function (err) {
        console.error('[ShippingProtection] bootstrap error', err);
      });
  }

  /* ── Variant swap (when cart subtotal changes tier) */

  function swapVariant(oldLineKey, newVariantId) {
    _isProcessing = true;
    var updates = {};
    updates[oldLineKey] = 0;
    return mutateCart('/cart/update.js', { updates: updates }, 'protection-tier-remove')
      .then(function () {
        return mutateCart('/cart/add.js', { items: [{ id: parseInt(newVariantId, 10), quantity: 1 }] }, 'protection-tier-add');
      })
      .then(function (data) {
        if (hasFullCartShape(data)) syncWidgets(data);
      })
      .catch(function (err) {
        console.error('[ShippingProtection] swap error', err);
      })
      .finally(function () {
        _isProcessing = false;
      });
  }

  /* ── Toggle handler (event delegation) ───────── */

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches(TOGGLE_SEL)) return;
    e.stopPropagation();
    if (_isProcessing) { e.target.checked = !e.target.checked; return; }
    _isProcessing = true;

    var toggle = e.target;
    var wantOn = toggle.checked;
    _visualToggleState = wantOn;
    var ui = toggle.closest(WIDGET_SEL);
    ui.classList.toggle('is--active', wantOn);

    if (wantOn) {
      doAdd(toggle, ui);
    } else {
      doRemove(toggle, ui);
    }
  });

  function doAdd(toggle, ui) {
    setMiniCartSubtotalShimmer(true);
    Promise.all([getCachedOrFetchCart(), discoverVariants()])
      .then(function (results) {
        var cart = results[0];
        var existing = findAllProtectionItems(cart);
        if (existing.length) {
          var updates = {};
          existing.forEach(function (item) { updates[item.key] = 0; });
          return mutateCart('/cart/update.js', { updates: updates }, 'protection-prune-before-add');
        }
        return cart;
      })
      .then(function (cart) {
        var subtotal = merchandiseSubtotal(cart);
        var variantId = selectVariantId(subtotal);
        var feeCents = effectiveFeeCents(subtotal);

        if (!variantId) throw new Error('No matching variant for fee $' + (feeCents / 100));

        var priceEl = ui ? ui.querySelector(PRICE_SEL) : null;
        var previewCents = discountedPreviewFeeCents(cart);
        if (priceEl) priceEl.textContent = formatMoney(previewCents);

        return mutateCart(
          '/cart/add.js',
          {
            items: [
              {
                id: parseInt(variantId, 10),
                quantity: 1
              }
            ]
          },
          'protection-add'
        ).then(function (data) {
          var lineKey = '';
          var addedItems = data && Array.isArray(data.items) ? data.items : [];
          if (addedItems.length) {
            var added = addedItems[addedItems.length - 1];
            if (added && added.key) lineKey = String(added.key);
          }
          return { data: data, variantId: variantId, previewCents: previewCents, lineKey: lineKey };
        });
      })
      .then(function (ctx) {
        var data = ctx.data;
        _visualToggleState = true;
        if (hasFullCartShape(data)) {
          syncWidgets(data);
        } else {
          /* Keep UI coherent even if /cart/add.js response is partial. */
          document.querySelectorAll(WIDGET_SEL).forEach(function (liveUI) {
            var liveToggle = liveUI.querySelector(TOGGLE_SEL);
            var livePrice = liveUI.querySelector(PRICE_SEL);
            if (liveToggle) {
              liveToggle.checked = true;
              liveToggle.dataset.variantId = String(ctx.variantId);
              if (ctx.lineKey) liveToggle.dataset.lineKey = String(ctx.lineKey);
            }
            if (livePrice) livePrice.textContent = formatMoney(ctx.previewCents);
            liveUI.classList.add('is--active');
          });
        }
      })
      .catch(function (err) {
        console.error('[ShippingProtection] add error', err);
        _visualToggleState = false;
        document.querySelectorAll(WIDGET_SEL).forEach(function (liveUI) {
          var liveToggle = liveUI.querySelector(TOGGLE_SEL);
          if (liveToggle) liveToggle.checked = false;
          liveUI.classList.remove('is--active');
        });
        if (window.ddToast) window.ddToast('Couldn\u2019t add protection \u2014 please try again', { type: 'error' });
      })
      .finally(function () {
        _isProcessing = false;
        /* Keep shimmer visible through mutation/section patch completion window. */
        window.setTimeout(function () {
          setMiniCartSubtotalShimmer(false);
        }, 220);
      });
  }

  function doRemove(toggle, ui) {
    setMiniCartSubtotalShimmer(true);
    ui.classList.remove('is--active');
    toggle.checked = false;
    var priceEl = ui ? ui.querySelector(PRICE_SEL) : null;
    var savedPrice = priceEl ? priceEl.textContent : '';
    if (priceEl) priceEl.textContent = '';

    var directLineKey = toggle && toggle.dataset ? String(toggle.dataset.lineKey || '') : '';
    var removePromise;
    if (directLineKey) {
      var directUpdates = {};
      directUpdates[directLineKey] = 0;
      removePromise = mutateCart('/cart/update.js', { updates: directUpdates }, 'protection-remove-direct')
        .then(function (data) {
          if (hasFullCartShape(data) && !findAnyProtectionItem(data)) return data;
          if (hasFullCartShape(data)) return forceRemoveAllProtection(data, 1);
          return getCachedOrFetchCart().then(function (cart) {
            return forceRemoveAllProtection(cart, 2);
          });
        })
        .catch(function () {
          return getCachedOrFetchCart().then(function (cart) {
            return forceRemoveAllProtection(cart, 2);
          });
        });
    } else {
      removePromise = getCachedOrFetchCart().then(function (cart) {
        return forceRemoveAllProtection(cart, 2);
      });
    }

    removePromise
      .then(function (data) {
        _visualToggleState = false;
        if (hasFullCartShape(data)) {
          syncWidgets(data);
          return;
        }
        document.querySelectorAll(WIDGET_SEL).forEach(function (freshUI) {
          freshUI.classList.remove('is--active');
          var freshToggle = freshUI.querySelector(TOGGLE_SEL);
          if (freshToggle) freshToggle.checked = false;
          var freshPrice = freshUI.querySelector(PRICE_SEL);
          if (freshPrice) freshPrice.textContent = savedPrice;
        });
      })
      .catch(function (err) {
        console.error('[ShippingProtection] remove error', err);
        _visualToggleState = true;
        document.querySelectorAll(WIDGET_SEL).forEach(function (liveUI) {
          var liveToggle = liveUI.querySelector(TOGGLE_SEL);
          if (liveToggle) liveToggle.checked = true;
          liveUI.classList.add('is--active');
          var livePrice = liveUI.querySelector(PRICE_SEL);
          if (livePrice) livePrice.textContent = savedPrice;
        });
        if (window.ddToast) window.ddToast('Couldn\u2019t remove protection \u2014 please try again', { type: 'error' });
      })
      .finally(function () {
        _isProcessing = false;
        /* Keep shimmer visible through mutation/section patch completion window. */
        window.setTimeout(function () {
          setMiniCartSubtotalShimmer(false);
        }, 220);
      });
  }

  /* ── Lifecycle ──────────────────────────────────── */

  document.addEventListener('drawer:opened', function () {
    var cached =
      window.ddCartHelpers && window.ddCartHelpers.getLatestCart
        ? window.ddCartHelpers.getLatestCart()
        : null;
    if (hasFullCartShape(cached)) {
      reconcileFromCart(cached);
      return;
    }
    bootstrapFromCart();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var data = event.cartData;
      if (hasFullCartShape(data)) {
        reconcileFromCart(data);
        return;
      }
      var latest =
        window.ddCartHelpers && window.ddCartHelpers.getLatestCart
          ? window.ddCartHelpers.getLatestCart()
          : null;
      if (hasFullCartShape(latest)) {
        reconcileFromCart(latest);
        return;
      }
      if (_isProcessing || _isReconciling) return;
      getCachedOrFetchCart()
        .then(function (freshCart) {
          if (hasFullCartShape(freshCart)) return reconcileFromCart(freshCart);
        })
        .catch(function (err) {
          console.warn('[ShippingProtection] authoritative reconcile read failed', err);
        });
    });
  }

  if (_isCartPage) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrapFromCart);
    } else {
      bootstrapFromCart();
    }
  } else {
    discoverVariants();
  }
})();
